import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/api/client";
import {
  getAvtalerQueryKey,
  postAvtalePrivatMutation,
  postAvtaleSelskapMutation,
} from "@/api/generated/@tanstack/react-query.gen";
import { useBestillingContext } from "../context";

export const useSaveBestilling = () => {
  const queryClient = useQueryClient();
  const { resetBestillingData } = useBestillingContext();

  const onSuccessCommon = () => {
    queryClient.invalidateQueries({
      queryKey: getAvtalerQueryKey({ client: httpClient }),
    });
    resetBestillingData();
  };
  return {
    privat: useMutation({
      ...postAvtalePrivatMutation({
        client: httpClient,
      }),
      onSuccess: (_, __, ___) => {
        onSuccessCommon();
      },
    }),
    selskap: useMutation({
      ...postAvtaleSelskapMutation({
        client: httpClient,
      }),
      onSuccess: (_, __, ___) => {
        onSuccessCommon();
      },
    }),
  };
};
